export default "__VITE_ASSET__Cp9HsJm4__"